import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export enum AriaLivePoliteness {
  Polite = "polite",
  Assertive = "assertive",
}

export interface AriaLiveMessage {
  id: string
  politeness: AriaLivePoliteness
  message: string
}

export interface AriaLiveState {
  messages: AriaLiveMessage[]
}

const initialState: AriaLiveState = {
  messages: [],
}

const ariaLiveSlice = createSlice({
  name: "ariaLive",
  initialState,
  reducers: {
    ariaLiveMessageSet: (
      state: AriaLiveState,
      { payload }: PayloadAction<AriaLiveMessage>,
    ) => {
      const existingIndex = state.messages.findIndex((m) => m.id === payload.id)
      if (existingIndex !== -1) {
        state.messages[existingIndex] = payload
      } else {
        state.messages.push(payload)
      }
    },
    ariaLiveMessageClearById: (
      state: AriaLiveState,
      { payload }: PayloadAction<string>,
    ) => {
      state.messages = state.messages.filter((m) => m.id !== payload)
    },
    ariaLiveReset: (state: AriaLiveState) => {
      state.messages = []
    },
  },
})

export const { ariaLiveMessageSet, ariaLiveMessageClearById, ariaLiveReset } =
  ariaLiveSlice.actions

export const selectAriaLive = (state: { ariaLive: AriaLiveState }) =>
  state.ariaLive

export const selectAriaLiveMessageById = (
  state: { ariaLive: AriaLiveState },
  id: string,
) => state.ariaLive.messages.find((m) => m.id === id)

export default ariaLiveSlice.reducer
